import React from 'react';
import ReactDOM from 'react-dom';
import {MainRouter} from './components/navigation/main';
import './assets/style/index.scss';
import {AppProvider} from './services/provider/app';

ReactDOM.render(<AppProvider><MainRouter /></AppProvider>,document.getElementById('root'));

